import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";
import { SVG_GRADIENT_BLUE } from '../Button/ButtonStyles';

export const useStyles = () => ({
    functionCardCollectionContainer: css({
        position: 'relative',
        cursor: 'pointer',
        boxSizing: "border-box",
        padding: 12,
        backgroundSize: "0% 100%",
        backgroundRepeat: "no-repeat",
        backgroundOrigin: "border-box",
        border: `3px solid ${Color.primary[600]}`,
        borderImage: `url('data:image/svg+xml;base64,${SVG_GRADIENT_BLUE}') 10% stretch`,
        backgroundImage: Color.gradient[100],
        transition: "all .15s ease-in-out",
        width: 285,
        "&:hover": {
            border: `3px solid ${Color.primary[400]}`,
            backgroundColor: Color.primary[400],
            color: `${Color.neutral[0]} !important`,
            "& svg": {
                color: `${Color.primary[100]} !important`
            }
        }
    }),
    functionCardCollectionContainerDragged: css({
        transform: 'rotate(3deg)',
        border: `3px solid ${Color.primary[400]}`,
        backgroundColor: Color.primary[400],
        color: `${Color.neutral[0]} !important`,
        "& svg": {
            color: `${Color.primary[100]} !important`
        }
    }),
    functionCardCollectionTextIconContainer: css({
        position: 'relative',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        paddingBottom: 6,
        "& svg": {
            width: 24,
            height: 24,
            color: Color.primary[200],
        }
    }),
    functionCardCollectionTextIcon: css({
        display: 'flex',
        alignItems: 'flex-start',
        maxWidth: '90%',
        marginTop: 8,
        "& svg": {
            marginRight: 6,
            color: Color.primary[500],
        }
    }),
    functionBoxCollectionNoteActionsContainer: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: 12,
        "& svg": {
            width: 24,
            height: 24
        }
    }),
    functionCollectionNoteActionsContainer: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    }),
    functionCollectionChipContainer: css({
        display: 'flex',
        alignItems: 'center',
        paddingBottom: 10,
    })
});
